import axios from 'axios'
import { Toast } from 'vant';
import Global from './Global';
const http=function(url, data, method = 'get', contentType = 1) {
    let header = {
        'content-type':contentType === 1 ? 'application/json' : 'application/x-www-form-urlencoded',
        'X-Token':localStorage.getItem('token')
    }
    for (let property in data) {
        if (data[property] == null) {
            delete data[property]
        }
    }

    return new Promise((resolve, reject) => {
        var that=this;
        axios({
            headers: header,
            method: method,
            url: url,
            data
        }).then(function (res) {
            /*console.log(res);*/
            if (res.status == 200) {
                var res_data=res.data;
                if(res_data.status&&res_data.status==100){
                    Toast({
                        message:'你还未登录，即将跳转登录',
                        duration:1000,
                        onClose:function () {
                            /*that.$router.replace('/user-center');*/
                          // sessionStorage.setItem('url',location.href);
                          localStorage.removeItem('token');
                          Global.goLogin();
                        }
                    });
                    return false;
                }
                resolve(res)
            } else if (res.status == 405) {
                Toast('请求方法错误');
            } /*else if (res.statusCode == 401) {
                Dialog.alert({message: res.info});
                uni.showToast({
                    icon: 'none',
                    title: '未登录或登录状态已超时',
                    duration: 1500
                });
                setTimeout(() => {
                    uni.reLaunch({
                        url: '/pages/login/index',
                    });
                }, 1500)
                store.commit('logout')
            }*/ else {
                Toast('请求错误:' + res.status);
            }
            /*let res=response.data;
            if(res.status===1){
                that.slide_list=response.data.items;
            }else{
                Dialog.alert({message: res.info});
            }*/
        }).catch(function (err) {
                /*console.log(error);*/
                /*that.closeLoading();*/
            console.log('request fail', err)
            if(!err.errMsg){
                Toast('请求错误');
            }else{
                Toast(err.errMsg);
            }
            reject(err)
        });
    })
}
export default http



// WEBPACK FOOTER //
// ./src/assets/js/url.js